import React, { FC } from 'react';
import TwDialog from '../../../../components/TwDialog/TwDialog';
import { ReactComponent as Warning } from '../../../../assets/icons/warning.svg';
import {
  TwButton,
  TwButtonType,
  TwLoadingButton
} from '../../../../components/TwButtons/TwButtons';
import { FuelCardProvider } from '../../../../redux/api/fuelcard/fuelcard.model';
import { useDeleteFuelCardConfigMutation } from '../../../../redux/api/fuelcard/fuelcardApi';
import useNotifications from '../../../../providers/Notifications/Notifications.provider';
import { getProviderLabel } from './ConnectModal';
interface DisconnectModalProps {
  open: boolean;
  username: string | null;
  provider: FuelCardProvider;
  onClickClose: () => void;
  onDelete?: () => void;
  divisionId: string;
}

const DisconnectModal: FC<DisconnectModalProps> = ({
  open,
  username,
  provider,
  onClickClose,
  onDelete,
  divisionId
}): JSX.Element => {

  const { addNotification } = useNotifications();

  const [deleteFuelCardConfig, { isLoading }] = useDeleteFuelCardConfigMutation();

  const handleDisconnect = (): void => {
    deleteFuelCardConfig({
      divisionId,
      fuelcardProvider: provider,
      username: username || ''
    })
      .unwrap()
      .then(() => {
        addNotification({
          message: 'Account disconnected successfully',
          variant: 'success',
          timeToShow: 3000
        });
        onDelete?.();
        onClickClose?.();
      })
      .catch((err) => {
        addNotification({
          message: 'Failed to disconnect account',
          variant: 'error',
          timeToShow: 3000
        });
        console.error('err', err);
      });
  };
  return (
    <TwDialog
      open={open}
      title={`Disconnect ${getProviderLabel(provider)} account?`}
      onClickClose={onClickClose}
    >
      <div className="warning">
        <Warning />
        <p className="warning__message">
          Are you sure you want to disconnect <strong>{username}</strong> {getProviderLabel(provider)} account? <br />
          You will be able to reconnect it later.
        </p>
        <div className="warning__actions">
          <TwButton
            fullwidth={false}
            label="Cancel"
            type={TwButtonType.secondary}
            action={onClickClose}
          />

          <TwLoadingButton
            fullwidth={false}
            label="Disconnect"
            type={TwButtonType.negative}
            action={handleDisconnect}
            loading={isLoading}
          />
        </div>
      </div>
    </TwDialog>
  );
};

export default DisconnectModal;
